import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fireCustomerIOEvent } from '~/client/common/customerio'
import { CustomerIOEventName } from '~/shared/customerio/customerio.types'
import { submitCreateShareableList } from './shareable-list.api'

export function useCreateShareableList() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createShareableList'],
    mutationFn: async ({ name, description, spaceId, venueGroupId }: { name: string; description?: string; spaceId?: number; venueGroupId?: number }) => {
      const result = await submitCreateShareableList({ name, description, spaceId, venueGroupId })
      if (result.list.id) {
        void fireCustomerIOEvent(CustomerIOEventName.CollectionCreated, {
          collection_id: result.list.id,
          name,
          had_initial_space: typeof spaceId === 'number',
        })
      }
      return result
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shareable-lists'] })
    },
  })
}
